type DisplayWidthConfig = {
  zh?: number
  en?: number
  emoji?: number
  other?: number
}

const DEFAULT_CONFIG: Required<DisplayWidthConfig> = {
  zh: 2,
  en: 1,
  emoji: 2,
  other: 1,
}

export function sliceTextByDisplayLength(
  str: string,
  maxUnits: number,
  config: DisplayWidthConfig = DEFAULT_CONFIG,
): string {
  const chars = Array.from(str)
  let totalUnits = 0
  let result = ''

  for (const char of chars) {
    let units = 0

    if (/[\u4e00-\u9fff]/.test(char)) {
      // 中文
      units = config.zh ?? DEFAULT_CONFIG.zh
    } else if (/\p{Extended_Pictographic}/u.test(char)) {
      // emoji（基於 Unicode 屬性）
      units = config.emoji ?? DEFAULT_CONFIG.emoji
    } else if (/[a-z0-9]/i.test(char)) {
      // 英文與數字
      units = config.en ?? DEFAULT_CONFIG.en
    } else {
      // 其他符號
      units = config.other ?? DEFAULT_CONFIG.other
    }

    if (totalUnits + units > maxUnits) {
      result += '...'

      break
    }

    result += char
    totalUnits += units
  }

  return result
}

export default sliceTextByDisplayLength
